import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * PWA share_target landing route. When a user shares a habano.app URL
 * (or any URL containing /places/:id or /vendors/:id) from another app
 * such as WhatsApp, the PWA opens here and we deep-link to the matching
 * profile. Falls back to home if no match.
 */
export default function Share() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const text = `${params.get("url") || ""} ${params.get("text") || ""} ${params.get("title") || ""}`;
    const place = text.match(/\/places\/([\w-]+)/);
    const vendor = text.match(/\/vendors\/([\w-]+)/);
    if (vendor) {
      navigate(`/vendors/${vendor[1]}`, { replace: true });
      return;
    }
    if (place) {
      navigate(`/places/${place[1]}`, { replace: true });
      return;
    }
    navigate("/", { replace: true });
  }, [params, navigate]);

  return (
    <main className="min-h-screen grid place-items-center bg-background" data-testid="share-landing">
      <div className="text-center">
        <Loader2 className="w-6 h-6 animate-spin mx-auto text-gold" strokeWidth={1.5}/>
        <div className="text-xs text-foreground/55 mt-3 uppercase tracking-widest">Opening Habano…</div>
      </div>
    </main>
  );
}
